<template>
  <div>
    <v-dialog persistent v-model="showSubscriptionDetailsDialog" width="480">
      <div class="ec-dialog">
        <div class="ec-dialog__header">
          <h2 class="ec-dialog__title">Subscription Details</h2>
          <button class="ec-icon-btn" @click="closeGeneratedLicenceKeysDialog">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>

        <div class="ec-dialog__body" style="padding:0">
          <div class="sd-list">
            <div class="sd-row">
              <span class="sd-label">Licence Name</span>
              <span class="sd-value">{{ subscriptionDetails.licence_name }}</span>
            </div>
            <div class="sd-row">
              <span class="sd-label">Limit</span>
              <span class="sd-value">{{ subscriptionDetails.limit }}</span>
            </div>
            <div class="sd-row">
              <span class="sd-label">Amount Per Month</span>
              <span class="sd-value">${{ subscriptionDetails.amount_per_month }}</span>
            </div>
            <div class="sd-row">
              <span class="sd-label">Total Amount</span>
              <span class="sd-value sd-value--bold">${{ subscriptionDetails.amount }}</span>
            </div>
            <div class="sd-row">
              <span class="sd-label">Subscription Type</span>
              <span class="sd-value" style="text-transform:uppercase">{{ subscriptionDetails.sub_type }}</span>
            </div>
            <div class="sd-row">
              <span class="sd-label">Status</span>
              <span class="sd-value">
                <span v-if="subscriptionDetails.is_canceled" class="u-status-pill u-pill--red">
                  Cancels at {{ timeParser(licenceEndtime) }}
                </span>
                <span v-else class="u-status-pill u-pill--green">
                  Renews at {{ timeParser(licenceEndtime) }}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="ec-dialog__footer" style="justify-content:flex-end">
          <button class="ec-btn ec-btn--ghost" @click="closeGeneratedLicenceKeysDialog">Close</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import converter from '@/mixins/converter'
export default {
  props: {
    generatedLicenceKeys: { type: Array, default: () => [] },
    showSubscriptionDetailsDialog: { type: Boolean, default: false },
    subscriptionDetails: { type: Object, required: true },
    licenceName: { type: String, required: true, default: '' },
    licenceEndtime: { type: String, required: true, default: '' }
  },
  data () {
    return {
      headersFeature: [
        { text: 'Licence Name', value: 'licence_name', align: 'left' },
        { text: 'Renewal type', value: 'sub_type', align: 'center' },
        { text: 'Per amount', value: 'amount_per_month', align: 'center' },
        { text: 'Total Amount', value: 'amount', align: 'center' },
        { text: 'Cancel', value: 'is_canceled', align: 'center' }
      ]
    }
  },
  mixins: [converter],
  methods: {
    closeGeneratedLicenceKeysDialog () {
      this.$emit('closeSubscriptionDetailsDialog')
    }
  }
}
</script>

<style scoped>
.sd-list {
  border-top: 1px solid var(--ec-border);
}
.sd-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--ec-border-light);
  transition: background .12s;
}
.sd-row:last-child { border-bottom: none; }
.sd-row:hover { background: var(--ec-bg); }
.sd-label {
  font-size: .8rem;
  color: var(--ec-text-3);
  font-weight: 500;
  white-space: nowrap;
}
.sd-value {
  font-size: .85rem;
  color: var(--ec-text-1);
  text-align: right;
}
.sd-value--bold { font-weight: 700; }
</style>
